import { memo, useEffect, useState } from "react";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { WATCHLIST_GRID_INDEX, SCRIP_INSTRUMENTS } from "../../utils/global_variables";
import { getOIDataForScripData, getFutureTabData } from "../../redux/actions/marketOverview";
import { convertToDate } from "../../utils/global_functions";
import ZeroStates from "../ZeroStates";

const OIBuildUp = () => {
  const OIBuildUPData1 = useSelector(state => state.marketOverview.OIDataForScrip1);
  const OIBuildUPData2 = useSelector(state => state.marketOverview.OIDataForScrip2);
  const OIBuildUPData3 = useSelector(state => state.marketOverview.OIDataForScrip3);
  const arrFutureData = useSelector(state => state.marketOverview.arrFutureTabData);
  const scripOverviewData = useSelector(
    (state) => state.marketOverview.scripOverviewData
  );
  const dispatch = useDispatch();
  // Vaibhav Singh: BT-109095:09-11-23:Fixed a Date Format updated to distictexpiry: Start
  let arrDate = arrFutureData?.map((item) => item.nExpiryDate1);

  const columnDefs = [
    { headerName: "Time", field: "Key", tb: 'time' },
    { headerName: Array?.from(new Set(arrDate))?.length ? `${new Date(Array.from(new Set(arrDate))[0]).getDate()} ${new Date(Array.from(new Set(arrDate))[0]).toLocaleString('default', { month: 'short' })} '${new Date(Array.from(new Set(arrDate))[0]).getFullYear() % 100}` : '-', field: 'Key', tb: 'OI1' },
    { headerName: Array?.from(new Set(arrDate))?.length ? `${new Date(Array.from(new Set(arrDate))[1]).getDate()} ${new Date(Array.from(new Set(arrDate))[1]).toLocaleString('default', { month: 'short' })} '${new Date(Array.from(new Set(arrDate))[0]).getFullYear() % 100}` : '-', field: 'Key', tb: 'OI2' },
    { headerName: Array?.from(new Set(arrDate))?.length ? `${new Date(Array.from(new Set(arrDate))[2]).getDate()} ${new Date(Array.from(new Set(arrDate))[2]).toLocaleString('default', { month: 'short' })} '${new Date(Array.from(new Set(arrDate))[0]).getFullYear() % 100}` : '-', field: 'Key', tb: 'OI3' },
  ];
  // Vaibhav Singh: BT-109095:09-11-23:Fixed a Date Format: End
  const [activeTabKey, setActiveTabKey] = useState('15min');
  const [timeMin, setTimeMin] = useState('sOIBuilUP');
  const [OIData, setOIData] = useState([]);
  useEffect(() => {
    if (activeTabKey === '30min') {
      setTimeMin('sOIBuilUP30Min');
    }
    if (activeTabKey === '60min') {
      setTimeMin('sOIBuilUP60Min');
    }
    if (activeTabKey === '15min') {
      setTimeMin('sOIBuilUP');
    }
  }, [activeTabKey]);
  useEffect(() => {
    const objPayload1 = {
      nToken: arrFutureData?.length ? arrFutureData[0]?.nToken : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
      jtenantToken: 1,
      expiry: '1',
      segmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
    };
    const objPayload2 = {
      nToken: arrFutureData?.length ? arrFutureData[1]?.nToken : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
      jtenantToken: 1,
      expiry: '2',
      segmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
    };
    const objPayload3 = {
      nToken: arrFutureData?.length ? arrFutureData[2]?.nToken : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
      jtenantToken: 1,
      expiry: '3',
      segmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
    };
    dispatch(getOIDataForScripData(objPayload1));
    dispatch(getOIDataForScripData(objPayload2));
    dispatch(getOIDataForScripData(objPayload3));
    dispatch(getFutureTabData({ symbol: scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK : scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] }));
  }, [scripOverviewData, dispatch]);
  useEffect(() => {
    if (OIBuildUPData1?.length) {
      setOIData(OIBuildUPData1[0][timeMin]);
    }
  }, [OIBuildUPData1, timeMin]);
  return (
    <>
      <Container fluid className='p-0'>
        <div className='scripoverview-fieldset'>
          <div className='scripoverview-fieldset-md'>
            <div className='scripoverview-legend'>OI BUILDUP OPTION</div>
            <Row className='g-0 mt-3'>
              <Col>
                <div className='submenu-wrapper pb-2'>
                  <Stack direction="horizontal" className='d-flex justify-content-start submenu-wrapper pb-3'>
                    <div className={`submenuItem ${activeTabKey === '15min' ? "active" : ''}`} isActive={activeTabKey === '15min' ? true : false} onClick={() => { setActiveTabKey('15min'); }} tabKey='15min'>15min</div>    {/* Bhagyashri P [20-11-2023] : BT-109095 Scrip Overview Analysis classes */}
                    <div className={`submenuItem ${activeTabKey === '30min' ? "active" : ''}`} isActive={activeTabKey === '30min' ? true : false} onClick={() => { setActiveTabKey('30min'); }} tabKey='30min'>30min</div>    {/* Bhagyashri P [20-11-2023] : BT-109095 Scrip Overview Analysis classes */}
                    <div className={`submenuItem ${activeTabKey === '60min' ? "active" : ''}`} isActive={activeTabKey === '60min' ? true : false} onClick={() => { setActiveTabKey('60min'); }} tabKey='60min'>60min</div>    {/* Bhagyashri P [20-11-2023] : BT-109095 Scrip Overview Analysis classes */}
                  </Stack>

                  <div className='so-oibuildup-height'>
                    <div className='table-responsive table-fixhead'>
                      {(OIBuildUPData1?.length || OIBuildUPData2?.length || OIBuildUPData3?.length) ?
                        <table className='table table-hover table-striped mt-3'>
                          <thead>
                            <tr>
                              {columnDefs.map((each, i) => (
                                <th key={i} className={`font-regular font-size2 table-th-color-text ${i === 0 ? 'text-start' : 'text-center'} col-md-3`}>{each.headerName}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {OIBuildUPData1?.length ? OIData?.map((each, i) =>
                              <tr key={i}>
                                {columnDefs?.map((tb, ind) => (
                                  <td className={`font-size2 ${ind === 0 ? 'font-regular table-td-color-subtext text-start' : 'font-medium table-td-color-text text-center'} col-md-3`} key={ind}>
                                    {ind === 0 && convertToDate(each['Key'], "hh:mm A")}
                                    {ind === 1 && each['Value']}
                                    {(ind === 2) ? (OIBuildUPData2?.length && OIBuildUPData2[0]?.[timeMin]?.[i]) ? OIBuildUPData2[0]?.[timeMin]?.[i]['Value'] : '-' : null}
                                    {(ind === 3) ? (OIBuildUPData3?.length && OIBuildUPData3[0]?.[timeMin]?.[i]) ? OIBuildUPData3[0]?.[timeMin]?.[i]['Value'] : '-' : null}

                                  </td>
                                ))}
                              </tr>
                            )
                              :
                              null
                            }
                          </tbody>
                        </table>
                        :
                        <div className='zero-state-alerts zero-state-alerts-lg'>
                          <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div>
                      }
                    </div>
                  </div>

                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
};
export default memo(OIBuildUp);